import { lazy, Suspense } from 'react';

import { LoadingScreen } from '@/components/feedback/loading-screen';

const PresalesSettingsPage = lazy(() =>
  import('@pages/settings/presales-settings').then((m) => ({
    default: m.PresalesSettingsPage,
  }))
);

export const presalesSettingsRoutes = [
  {
    path: 'presales',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <PresalesSettingsPage />
      </Suspense>
    ),
  },
];
